import React, { useState, useEffect, useRef } from 'react'
import api from '../components/api'
import JoditEditor from "jodit-react"
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import moment from 'moment'

const Modal = (props) => {

    const us_codigo = sessionStorage.getItem('us_codigo')

    const formulario_id = props.formulario_id
    const origem = props.origem
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()

    const [titulo, setTitulo] = useState('')
    const [texto, setTexto] = useState('')
    const [email, setEmail] = useState('')
    const [emailR, setEmailR] = useState('redephs@hospitaissaudaveis.org')
    const [nomeFantasia, setNomeFantasia] = useState('')
    const [emailGerado, setEmailGerado] = useState(false)
    const [totalErros, setTotalErros] = useState(0)
    const [resultadoEmail, setResultadoEmail] = useState('')

    //var [linkRecuperacaoSenha, setLinkRecuperacaoSenha] = useState()
    
    
    //var [autor, setAutor] = useState(sessionStorage.getItem('nome'))
    //var ad_usr = sessionStorage.getItem('us_codigo')


    const editor = useRef(null)
    const [content, setContent] = useState('')






    const [config, setConfig] = useState({
        readonly: false,
        toolbar: true,
        height: 300,
        placeholder: 'Escreva aqui...',
      })




    const carregaEmail = () => {

        api.get(`usuario/${us_codigo}`).then((result) => {

            var data = result.data
            
            //setEmail(data.email ? data.email : '')
            setResultadoEmail(data.map((rs) =>

                rs.senhaEmail ?
            
                    <option value={`${rs.email}`}>{rs.email}</option>

                :

                    null

            ))
            

        }).catch((err) => {

            console.log(err.response)

        })



    }



      const dadosInstituicao = () => {

        if (adesao_institucional_id) {


            api.get(`adesaoInstitucionalListaUm/${adesao_institucional_id}`).then((result) => {

                //console.log(result.data)
                var data = result.data[0]
                
                setEmail(data.emailRepresentante)
                setNomeFantasia(data.nome_fantasia)

            }).catch((err) => {

                console.log(err.response)

            })


        }

      }

      const enviaMail = () => {


            if (titulo == '') {

                window.toastr.error('<b>T&iacute;tulo</b> não pode ficar em branco!')
                return false

            }

            if (email == '') {

                window.toastr.error('<b>E-mail</b> não pode ficar em branco!')
                return false

            }

            if (texto == '') {

                window.toastr.error('<b>Texto</b> não pode ficar em branco!')
                return false

            }


            var dataPost = {

                adesao_institucional_id: adesao_institucional_id,
                titulo: titulo,
                texto: texto,
                email: email,
                emailR: emailR,
                ano: ano,
                formulario_id: formulario_id,
                usuarioEnvio: sessionStorage.getItem('nome'),
                desafio: origem,

            }

            //console.log(dataPost)


            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'green',
                title: 'Confirmação',
                content: 'Confirma enviar o e-mail?',
                buttons: {
                    Sim: function () {

                        //console.log(dataPost)
        
                        api.post('emailCorrecoesDesafio', dataPost).then((result) => {

                            console.log(result.data)
                            window.$("#ModalEmailCorrecao").modal('hide');
                            setVerificaDesafio(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.success('E-mail enviado com sucesso!')
                            

                        }).catch((err) => {
                        
                            console.log(err.response)

                        })

                    

                        

                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }

                },

            });




      }


      const dadosValidacao = () => {



            var dataPost = {

                formulario_id,
                desafio: origem,

            }


            api.post('desafioValidaVarios', dataPost).then((result) => {

                    
                var data = result.data
                var totalErros = 0
                //console.log(data, 'valid')

                for (var k = 0; k < data.length; k++) {

                    if (data[k].status == 'Erro') {

                        var totalErros = totalErros + 1

                    }
                }

                setTotalErros(totalErros)

            }).catch((err) => {

                console.log(err.response)

            })

      }


      useEffect(() => {

        dadosInstituicao()
        dadosValidacao()
        setContent('')
        //setTitulo('')
        setTexto('')

      }, [formulario_id, verificaDesafio])


      //console.log(origem)


      useEffect(() => {

        switch (origem) {

            case 'Resíduos':

                var nomeDesafio = 'Desafio Resíduos'

            break

            case 'Clima':
                
                var nomeDesafio = 'Desafio Clima'

            break

            case 'Compras':
                
                var nomeDesafio = 'Desafio Compras'

            break

            case 'Energia':
                
                var nomeDesafio = 'Desafio Energia'

            break

            case 'PerfilAnual':
                
                var nomeDesafio = 'Perfil Anual'

            break


        }

        if (totalErros > 0) {

            setTitulo(`[Hospitais Saudáveis] Correções no ${nomeDesafio} ${ano} - ${nomeFantasia}`)

            var txt = `
                    
            Prezado <b>${nomeFantasia}</b>,<br><br>
            
            Existem <b><font color='red'>${totalErros}</font></b> pendência(s) em seu preenchimento no formulário do <b><font color='green'>${nomeDesafio}</font></b> do ano de <b><font color='orange'>${ano}</font></b>. Você pode acompanhar as observações na seção <b>Gestão de Pendências</b>
            do seu desafio.<br><br>
            

            Atenciosamente,<br>
            <font color="brown">Projeto Hospitais Saudáveis</font>
            `

            setContent(txt)

        }


      }, [origem, nomeFantasia, totalErros])

      useEffect(() => {

        setTexto(content)

      }, [content])

      useEffect(() => {
        
        carregaEmail()

      }, [])

    return (

        <div>

            <div className="modal fade" id="ModalEmailCorrecao" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">E-mail</h1>
                        </div>
                        <div class="modal-body">
                                
                                <div className="panel-body">
                                    
                                    
                                    <div className="col-md-12">
                                        <div class="form-group">
                                            <label>E-mail remetente</label>
                                            <select className="form-control" value={emailR} onChange={event => setEmailR(event.target.value)}>
                                                <option value="redephs@hospitaissaudaveis.org">redephs@hospitaissaudaveis.org</option>
                                                {resultadoEmail}
                                            </select>
                                                            
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div class="form-group">
                                            <label>E-mail destino</label>
                                            
                                            <input type="text" className="form-control" value={email} onChange={event => setEmail(event.target.value)} />
 
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div class="form-group">
                                            <label>Título/Assunto</label>
                                            <input type="text" value={titulo} onChange={event => setTitulo(event.target.value)} className="form-control" placeholder="" maxLength={500} />
                                                            
                                        </div>
                                    </div>


                                    <div class="col-md-12">

                                        <div class="form-group">
                                            <label>Texto</label>
                                                    
                                            <JoditEditor 
                                                ref={editor}
                                                value={content}
                                                config={config}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={newContent => setTexto(newContent)} // preferred to use only this option to update the content for performance reasons
                                                onChange={newContent => {}}
                                            />

                                                            
                                        </div>

                                    </div>


                                    

                                </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            
                            <button type="button" className="btn btn-success" onClick={() => enviaMail()}>Enviar e-mail</button>
                            
                        </div>
                    </div>
                </div>
            </div>


        </div>

    )

}

export default Modal